<script setup lang="ts">
import { useAlgoliaInsights } from '@design-system/composables/useAlgoliaInsights'

const { cart, lineItemsWithAlgoliaData } = useCart()
const { dispatchActionFinalizeOrderButtonEvent } = useGAActionEvents()
const checkoutStepNavigation = useCheckoutStepNavigation()
const { purchasedProduct } = useAlgoliaInsights()
const selectedPaymentMethod: Ref<string | undefined> = useState(
  'selectedPaymentMethod',
  () => undefined
)
const currentAlgoliaIndex = useAppConfig().currentAlgoliaIndex
const sendGAFinalizeOrder = () => {
  if (
    cart?.value?.shipments &&
    checkoutStepNavigation.currentStep.value?.id === 'CheckoutPayment'
  ) {
    dispatchActionFinalizeOrderButtonEvent(
      cart.value?.currency_code!,
      cart.value?.total_amount_float!,
      cart.value?.shipments[0].shipping_method?.reference!,
      cart.value?.payment_method?.name!
    )
    const objectIds =
      lineItemsWithAlgoliaData?.value.map(
        item => item._algolia?.objectID || ''
      ) || []

    const objectsData = lineItemsWithAlgoliaData?.value?.map(item => {
      return {
        price: item.total_amount_float,
        discount: item.discount_float || 0,
        quantity: item.quantity,
        queryID: item.metadata?.queryID || undefined,
      }
    })
    purchasedProduct(
      currentAlgoliaIndex,
      'Products Purchase',
      objectIds,
      objectsData || undefined,
      cart?.value?.currency_code || undefined,
      cart?.value?.subtotal_amount_float || undefined
    )
  }
}

const runFunction = () => {
  if (selectedPaymentMethod.value === 'applepay') {
    const applePayButton = document.getElementById('applepay-checkout')
    if (applePayButton) {
      applePayButton.click()
    }
  } else {
    checkoutStepNavigation.handleContinueButtonClick(
      checkoutStepNavigation.currentStep.value.id
    )
  }
  sendGAFinalizeOrder()
}
</script>

<template>
  <Transition name="hide-bar">
    <div
      v-if="checkoutStepNavigation.showCta.value"
      class="checkout-step-navigation bg-primitives-white sticky bottom-0 left-0 flex w-full justify-center py-6"
    >
      <AtomsCta
        :disabled="!checkoutStepNavigation.isActive.value"
        @click-handler="runFunction"
      >
        <template #label>
          {{ checkoutStepNavigation.currentStep.value?.label }}
        </template>
      </AtomsCta>
    </div>
  </Transition>
</template>

<style scoped lang="scss">
/* HIDE STRIP */
.hide-bar-enter-active,
.hide-bar-leave-active {
  transition: all 0.3s ease;
}

.hide-bar-enter-from,
.hide-bar-leave-to {
  @apply translate-y-full;
}
</style>
